import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import { Box, Typography } from '@mui/material';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip);

const DoughnutChart = ({ obtained, total, label, sx, disabled = false, displayText }) => {
  // Chart data
  const data = {
    datasets: [
      {
        data: disabled ? [0, total] : [obtained, total - obtained],
        backgroundColor: disabled ? ['#E0E0E0', '#E0E0E0'] : ['green', 'red'], // Gray for disabled, green/red for active
        borderWidth: 0,
      },
    ],
  };

  // Chart options to make it a doughnut chart
  const options = {
    cutout: '70%', // Makes it a doughnut chart
    plugins: {
      tooltip: {
        enabled: !disabled, // Disable tooltips when disabled
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <Box
      sx={{
        ...sx,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        // opacity: disabled ? 0.5 : 1, // Reduce opacity for disabled state
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <Doughnut
          data={data}
          options={options}
          width={148.6} // Hardcoded to 148.6px
          height={148.6} // Hardcoded to 148.6px
        />
        {/* Display marks or displayText in the center */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: '12.64px',
              fontWeight: 500,
              color: disabled ? '#999' : '#7b7a80',
            }}
          >
            Marks
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: '20px',
              fontWeight: 1000,
              color: disabled ? '#999' : '#1976d2',
            }}
          >
            {displayText || `${obtained}/${total}`}
          </Typography>
        </Box>
      </Box>
      {/* Display label below the chart */}
      <Box sx={{ textAlign: 'center', mt: 1 }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: '20px',
            fontWeight: 600,
            color: '#1976D2',
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default DoughnutChart;